import { Settlement } from "../Settlement";
import { Button, DataHeader, DataSource, Layout } from "@mcleod/components";

export abstract class AutogenLayoutSettlementHistory extends Layout {
    buttonOrderHistory: Button;
    buttonResponsibility: Button;
    dataheaderSettlementHistory: DataHeader;
    layoutSettlement: Settlement;
    sourceComments: DataSource;
    sourceDrsDeductHist: DataSource;
    sourceDrsSettleHist: DataSource;
    sourceJournalDriver: DataSource;
}
